export type QualityTier = 'high' | 'medium' | 'low'

export interface QualityConfig {
  dpr: number
  particles: number
  bloom: boolean
  afterimage: boolean
  distortion: boolean
  pixelRatioCap: number
}

export const QUALITY_PRESETS: Record<QualityTier, QualityConfig> = {
  high: {
    dpr: 1.5,
    particles: 6000,
    bloom: true,
    afterimage: true,
    distortion: true,
    pixelRatioCap: 2,
  },
  medium: {
    dpr: 1.25,
    particles: 3000,
    bloom: true,
    afterimage: true,
    distortion: false,
    pixelRatioCap: 1.5,
  },
  low: {
    dpr: 1,
    particles: 800,
    bloom: true,
    afterimage: false,
    distortion: false,
    pixelRatioCap: 1,
  },
}

export interface HysteresisConfig {
  downFps: number
  downSeconds: number
  upFps: number
  upSeconds: number
}

export const DEFAULT_HYSTERESIS: HysteresisConfig = {
  downFps: 50,
  downSeconds: 2,
  upFps: 58,
  upSeconds: 5,
}

const TIER_ORDER: QualityTier[] = ['low', 'medium', 'high']

export function estimateFps(samples: number[]): number {
  if (samples.length === 0) return 60
  const sum = samples.reduce((a, b) => a + b, 0)
  return sum / samples.length
}

export function nextTier(
  current: QualityTier,
  fps: number,
  cfg: HysteresisConfig,
  lowStreakSec: number,
  highStreakSec: number,
): { tier: QualityTier; lowStreakSec: number; highStreakSec: number } {
  const idx = TIER_ORDER.indexOf(current)
  if (fps < cfg.downFps) {
    const nextLow = lowStreakSec + 1 / 60
    if (nextLow >= cfg.downSeconds && idx > 0) {
      return { tier: TIER_ORDER[idx - 1], lowStreakSec: 0, highStreakSec: 0 }
    }
    return { tier: current, lowStreakSec: nextLow, highStreakSec: 0 }
  }
  if (fps > cfg.upFps) {
    const nextHigh = highStreakSec + 1 / 60
    if (nextHigh >= cfg.upSeconds && idx < TIER_ORDER.length - 1) {
      return { tier: TIER_ORDER[idx + 1], lowStreakSec: 0, highStreakSec: 0 }
    }
    return { tier: current, lowStreakSec: 0, highStreakSec: nextHigh }
  }
  return { tier: current, lowStreakSec: 0, highStreakSec: 0 }
}
